import { getCurrencies } from '@services/queries'
import { useQuery } from 'react-query'

export function useCurrencies() {
  const info = useQuery(['currencies'], getCurrencies)

  return info
}
